import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Book.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeMute, faVolumeUp } from '@fortawesome/free-solid-svg-icons';

function IndexPage() {
    const [librosProximos, setLibrosProximos] = useState([]);
    const [novedades, setNovedades] = useState([]);
    const [librosColeccion, setLibrosColeccion] = useState([]);
    const [podcastsVideopodcasts, setPodcastsVideopodcasts] = useState([]);
    const [documentales, setDocumentales] = useState([]);
    const [series, setSeries] = useState([]);
    const [libroAleatorioBanner, setLibroAleatorioBanner] = useState(null);
    const [isMuted, setIsMuted] = useState(true);
    let libroAleatorio;
    let ruta_trail = "";
    let bannerVideoUrl = "";
    useEffect(() => {
        const fetchLibros = async () => {
            try {
                const response = await axios.get('/api/objetos');
                const allLibros = response.data;

                function parseFecha(fechaStr) {
                    const [dia, mes, anio] = fechaStr.split("/");
                    return new Date(`${anio}-${mes}-${dia}`);
                }

                const publicados = allLibros
                    .filter(libro => parseInt(libro.status) === 1)
                    .sort((a, b) => parseFecha(b.fecha) - parseFecha(a.fecha));

                // Distribución fija de "Novedades" por tipo de contenido:
                // 3 Libros (idTipo 1) | 1 Serie (idTipo 6) | 3 Podcast/Videopodcast (idTipo 4) | 1 Documental (idTipo 5)
                const librosRecientes = publicados
                    .filter(libro => parseInt(libro.idTipo) === 1)
                    .slice(0, 3);

                const seriesRecientes = publicados
                    .filter(libro => parseInt(libro.idTipo) === 6)
                    .slice(0, 1);

                const podcastsRecientes = publicados
                    .filter(libro => parseInt(libro.idTipo) === 4)
                    .slice(0, 3);

                const documentalesRecientes = publicados
                    .filter(libro => parseInt(libro.idTipo) === 5)
                    .slice(0, 1);

                // Se combinan y se reordenan por fecha para que se muestren mezclados cronológicamente
                const filteredNovedades = [
                    ...librosRecientes,
                    ...seriesRecientes,
                    ...podcastsRecientes,
                    ...documentalesRecientes
                ].sort((a, b) => parseFecha(b.fecha) - parseFecha(a.fecha));

                // console.log(JSON.stringify(filteredNovedades));
                setNovedades(filteredNovedades);

                const filteredProximamente = allLibros.filter(libro => parseInt(libro.status) === 2);
                setLibrosProximos(filteredProximamente);

                const filteredLibros = allLibros.filter(libro => parseInt(libro.status) === 1 && parseInt(libro.idTipo) === 1);
                setLibrosColeccion(filteredLibros);

                const filteredPodcastsVideopodcasts = allLibros.filter(libro => parseInt(libro.status) === 1 && parseInt(libro.idTipo) === 4);
                setPodcastsVideopodcasts(filteredPodcastsVideopodcasts);
                // console.log("Podcasts y Videopodcasts cargados:", filteredPodcastsVideopodcasts); // Para depuración

                const filteredDocumentales = allLibros.filter(libro => parseInt(libro.status) === 1 && parseInt(libro.idTipo) === 5);
                setDocumentales(filteredDocumentales);

                const filteredSeries = allLibros.filter(libro => parseInt(libro.status) === 1 && parseInt(libro.idTipo) === 6);
                setSeries(filteredSeries);

                const librosParaBanner = allLibros.filter(libro =>
                    parseInt(libro.status) === 1 &&
                    (parseInt(libro.idTipo) === 1)
                );

                if (librosParaBanner.length > 0) {
                    const posicion = Math.floor(Math.random() * librosParaBanner.length);
                    libroAleatorio = librosParaBanner[posicion];
                    console.log(JSON.stringify(libroAleatorio));
                    bannerVideoUrl = `https://bibliotecahumana.urosario.edu.co/imagenes/${libroAleatorio.idObjeto}/trailer.mp4`;

                    setLibroAleatorioBanner({
                        ...libroAleatorio,
                        ruta: bannerVideoUrl
                    });
                } else {
                    setLibroAleatorioBanner({
                        idObjeto: 122,
                        Titulo: "Cinco voces, cinco territorios",
                        descripcion: "",
                        url_libro: "/libro/122",
                        ruta: "https://bibliotecahumana.urosario.edu.co/libro/122"
                    });
                }

            } catch (error) {
                console.error('Error al obtener libros:', error);
            }
        };
        fetchLibros();
    }, []);

    // Función para generar la configuración del slider basada en la cantidad de elementos
    const getSliderSettings = (dataLength, isProximamente = false) => {
        const defaultSettings = {
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            infinite: dataLength > 4, // Infinite solo si hay suficientes elementos para rellenar 4 slides
            speed: 300,
            slidesToShow: Math.min(dataLength, 4), // Mostrar hasta 4, pero no más que la cantidad de elementos
            slidesToScroll: Math.min(dataLength, 4),
            centerMode: dataLength > 4, // Center mode solo si hay suficientes slides
            centerPadding: '10px',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: Math.min(dataLength, 4),
                        slidesToScroll: Math.min(dataLength, 4),
                        infinite: dataLength > 4,
                        dots: true,
                        centerMode: dataLength > 4,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: Math.min(dataLength, 2),
                        slidesToScroll: Math.min(dataLength, 2),
                        infinite: dataLength > 2,
                        centerMode: dataLength > 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: Math.min(dataLength, 1),
                        slidesToScroll: Math.min(dataLength, 1),
                        infinite: dataLength > 1,
                        centerMode: false, // Generalmente no útil para 1 slide
                    }
                },
                {
                    breakpoint: 468,
                    settings: {
                        autoplay: true,
                        autoplaySpeed: 8000,
                        slidesToShow: Math.min(dataLength, 1),
                        slidesToScroll: Math.min(dataLength, 1),
                        infinite: dataLength > 1,
                        centerMode: false,
                    }
                },
            ],
        };

        if (isProximamente) {
            // Ajustes específicos para "Próximamente" si difieren mucho
            defaultSettings.autoplay = false; // "Próximamente" no se auto-reproduce
            defaultSettings.dots = true; // Podrías querer puntos siempre
            defaultSettings.infinite = dataLength > 4; // También para próximamente, solo si hay suficientes elementos
            defaultSettings.slidesToShow = Math.min(dataLength, 4);
            defaultSettings.slidesToScroll = Math.min(dataLength, 4);
            defaultSettings.centerMode = false; // Raramente útil para próximos
            defaultSettings.centerPadding = '0px'; // Sin padding central
            // Ajustar responsives de Proximamente si slidesToShow es 1 o 2 y hay menos elementos
            defaultSettings.responsive.forEach(res => {
                res.settings.infinite = dataLength > res.settings.slidesToShow;
                res.settings.slidesToShow = Math.min(dataLength, res.settings.slidesToShow);
                res.settings.slidesToScroll = Math.min(dataLength, res.settings.slidesToScroll);
                // Si slidesToShow es 1, centerMode no tiene sentido
                if (res.settings.slidesToShow <= 1) {
                    res.settings.centerMode = false;
                }
            });
        }
        return defaultSettings;
    };

    const toggleMute = () => {
        const video = document.getElementById('background-video');
        if (video) {
            video.muted = !video.muted;
            setIsMuted(video.muted);
        }
    };

    const renderBookSlider = (title, data, allowClick = true) => {
        // Generar la configuración del slider basada en los datos específicos de esta sección
        const sliderSettings = getSliderSettings(data.length, title === "PRÓXIMAMENTE");

        return (
            <div className="container mt-5">
                <h3 className="Subtituloseccion">{title}</h3>
                {data.length > 0 ? (
                    <Slider {...sliderSettings}>
                        {data.map((libro) => (
                            <div key={libro.idObjeto} className="book-container m-2">
                                <a
                                    href={allowClick ? libro.url_libro : '#'}
                                    className="book-link"
                                    onClick={(e) => {
                                        if (!allowClick) {
                                            e.preventDefault();
                                        }
                                        // Si quieres abrir en un iframe como antes, puedes reincorporar la lógica aquí:
                                        // if (allowClick && libro.url_libro.includes('vimeo.com')) { // Ejemplo para Vimeo
                                        //   e.preventDefault();
                                        //   setVerLibro(libro.url_libro); // Necesitarías el estado `verLibro` y su lógica de iframe
                                        // }
                                    }}
                                >
                                    <img src={libro.url_caratula} alt={libro.Titulo} className="book-image" />
                                    <div className="book-description">
                                        <p className="texto-justify">{libro.descripcion.slice(0, 500)}</p>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <p>No hay contenido disponible en esta sección.</p>
                )}
            </div>
        );
    };

    return (
        <div>
            <Header />
            {/* {(console.log(JSON.stringify(libroAleatorioBanner))) } */}
            {/* Banner Principal */}
            <div className="banner">

                {libroAleatorioBanner ? (

                    <>
                        <video autoPlay loop muted={isMuted} playsInline id="background-video">
                            <source src={libroAleatorioBanner.ruta} type="video/mp4" />
                            Tu navegador no soporta el tag de video.
                        </video>

                        <div className="banner-message">
                            <h2 className="tituloLibro">{libroAleatorioBanner.Titulo}</h2>
                            {/* <p className="text">{libroAleatorioBanner.descripcion.slice(0, 100)}{libroAleatorioBanner.descripcion.length > 100 ? '...' : ''}</p> */}
                            <p className="ver_ahora text mb-md-5">
                                <a href={libroAleatorioBanner.url_libro} className="btn btn_ver_ahora">Ver ahora</a>
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <h2 className="tituloLibro">Cargando contenido...</h2>
                        <p className="text">Explora nuestra colección.</p>
                        <p className="ver_ahora text mb-md-5">
                            <a href='/libro/122' className="btn btn_ver_ahora">Ver ahora</a>
                        </p>

                    </>
                )}

                <div style={{ position: 'absolute', bottom: 0, right: 0, padding: '10px' }}>
                    <button onClick={toggleMute} style={{ background: 'none', border: 'none', cursor: 'pointer' }} title={isMuted ? "Activar sonido" : "Desactivar sonido"}>
                        {isMuted ?
                            <FontAwesomeIcon icon={faVolumeMute} style={{ color: "#FFF" }} className="fa-lg" /> :
                            <FontAwesomeIcon icon={faVolumeUp} style={{ color: "#FFF" }} className="fa-lg" />
                        }
                    </button>
                </div>
            </div>

            {/* Secciones de Sliders */}
            {/*             {renderBookSlider("NOVEDADES", novedades)}
            {renderBookSlider("PRÓXIMAMENTE", librosProximos, false)}
            {renderBookSlider("LIBROS", librosColeccion)}
            {renderBookSlider("PODCASTS Y VIDEOPODCASTS", podcastsVideopodcasts)}
        {renderBookSlider("DOCUMENTALES", documentales)} */}
            {novedades.length > 0 && renderBookSlider("NOVEDADES", novedades)}
            +            {librosProximos.length > 0 && renderBookSlider("PRÓXIMAMENTE", librosProximos, false)}
            +            {librosColeccion.length > 0 && renderBookSlider("LIBROS", librosColeccion)}
            +            {series.length > 0 && renderBookSlider("SERIES", series)}
            +            {podcastsVideopodcasts.length > 0 && renderBookSlider("PODCAST Y VIDEOPODCAST", podcastsVideopodcasts)}
            +            {documentales.length > 0 && renderBookSlider("DOCUMENTALES", documentales)}
            <Footer />
        </div>
    );
}

export default IndexPage;